import React, { Component } from 'react';
import './Style.css';
import './SimulatorResponsive.css';
import { MDBIcon, MDBInput } from 'mdbreact';
//RQTO. CRÉDITO DIGITAL FASE II 2026
import { ProductosDetallesGET_, ProductosSimula_, Simulacion_, ValidarCondicionesProductoSimula_ } from '../../services/WebAPI_Utrahuilca';
import { URLImgFront } from '../../config/URLDB';
import FormAsesoria from '../Formularios/FormAsesoria';
//RQTO. CDAT Y AHORRO DIGITAL 2025 - AMP
import FormAsesoriaDigital from '../Formularios/FormAsesoriaDigital';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import Loading from '../Loading';

const recaptchaRef = React.createRef();

const formatterPeso = new Intl.NumberFormat('es-CO', {
    currency: 'COP',
    minimumFractionDigits: 0
})

//RQTO. CRÉDITO DIGITAL FASE II 2026
const validate = values => {
    const errors = {}
    if (!values.monto) {
        errors.monto = 'Debes ingresar una cantidad.'
    }
    if (!values.plazo) {
        errors.plazo = 'El plazo es obligatorio.'
    }
    return errors;
};

class Simula extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            montoSimulado: 0,
            plazoSimulado: 0,
            stateContent: true,
            stateDollar: false,
            simuladorData: [],
            rutaImg: '',
            descripcion: '',
            color: '',
            nombprodutra: '',
            stateBVertical: false,
            stateBHorizontal: false,
            stateCampos: false,
            stateLoadign: false,
            interes_ahorro: 0,
            valor_renta: 0,
            gmf: 0,
            tasa_n_anual: 0,
            //RQTO. CRÉDITO DIGITAL FASE II 2026
            tasa_e_anual: 0,
            pasarela: false,
            formBlocker: false
        };
    }

    componentDidMount() {
        this.active();
        this.cargarInformacion();
    }

    cargarInformacion = () => {
        const nameP = this.props.match.params.name;
        //RQTO. CDAT Y AHORRO DIGITAL 2025 - AMP
        const prolineahorros = this.props.location?.state?.origen;

        if (nameP === "Ahorros" || nameP === "Credito") {
            const data = {
                tran: 7,
                idprodutra: 0,
                nombprodutra: 'NA',
                descprodutra: 'NA',
                rutaimgprod: 'NA',
                rutavistaprod: 'NA',
                //RQTO. CDAT Y AHORRO DIGITAL 2025 - AMP - prolinea AGREGADO
                prolinea: nameP === 'Ahorros' ? prolineahorros : 0, // SOLO SI ES DE AHORROS ENVIO LA LINEA
                idtipoprod: nameP === 'Ahorros' ? 1 : 2,
                idtipopers: 1,
                estado: 1,
                usucrea: 'NA',
                rutaproddet: 'NA'
            }
            ProductosSimula_(data).then(response => {
                try {
                    if (response.data.length > 0) {
                        if (response.data.length >= 1) {
                            if (response.data[0].message === "004404") {
                                this.setState({
                                    stateSimu: false
                                })
                            } else {
                                //RQTO. CRÉDITO DIGITAL, FASE II - JPGM/OASU 2026
                                const idProdUtra = parseInt(sessionStorage.getItem("idprodutra"));
                                const productoInicial = idProdUtra ? response.data.find(e => e.idprodutra === idProdUtra) ?? response.data[0] : response.data[0];
                                response.data.map((e) => {
                                    if (e.posicion === 1) {
                                        this.setState({
                                            stateBVertical: true
                                        })
                                    }
                                    if (e.posicion === 0) {
                                        this.setState({
                                            stateBHorizontal: true
                                        })
                                    }
                                    return [];
                                })
                                this.setState({
                                    simuladorData: response.data,
                                    //RQTO. CRÉDITO DIGITAL, FASE II - JPGM/OASU 2026
                                    idprodutra: productoInicial.idprodutra,
                                    prolinea: productoInicial.prolinea,
                                    rutaImg: productoInicial.rutafondosimul,
                                    descripcion: productoInicial.descsimulador,
                                    color: productoInicial.color,
                                    nombprodutra: productoInicial.nombprodutra,
                                    stateImg: true,
                                    stateSimu: true,
                                    idPintar: productoInicial.idsimuladorprod,

                                    //RQTO. CDAT Y AHORRO DIGITAL 2025 - AMP
                                    idtipocuenta: productoInicial.idtipocuenta,
                                    idclasificprod: productoInicial.idclasificprod,
                                    idtipoprod: productoInicial.idtipoprod
                                    //RQTO. CRÉDITO DIGITAL FASE II 2026
                                    //})
                                }, () => {
                                    this.checkProductSimulatorAttribute();
                                });

                                //RQTO. CDAT Y AHORRO DIGITAL 2025 - AMP
                                //if (response.data[0].idprodutra === 12) {
                                if (productoInicial.idtipoprod === 1) { //MODIFICADA AMP - 2025
                                    this.setState({
                                        stateCampos: true
                                    })
                                } else {
                                    this.setState({
                                        stateCampos: false
                                    })
                                }

                                //RQTO. CRÉDITO DIGITAL, FASE II - JPGM/OASU 2026
                                document.getElementById('' + productoInicial.idsimuladorprod + '').style.filter = "drop-shadow(8px 8px 10px " + productoInicial.color + ")";
                                document.getElementById('' + productoInicial.idsimuladorprod + '').style.fontWeight = "bold";
                            }
                        } else {
                            this.setState({
                                stateSimu: false
                            })
                        }
                    } else {

                    }
                } catch (error) {
                    console.log(error);
                }
            });
        } else {
            this.props.history.push('/404')
        }
    }

    active = () => {
        var header = document.getElementById("list_productos");
        var btns = header.getElementsByClassName("li");
        for (var i = 0; i < btns.length; i++) {
            btns[i].addEventListener("click", function () {
                var current = document.getElementsByClassName("active");
                current[0].className = current[0].className.replace(" active", "");
                this.className += " active";
            });
        }
    }

    textInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onSubmit = () => {
        //RQTO. CDAT Y AHORRO DIGITAL 2025 - AMP - SE AGREGA idclasificprod
        const { idclasificprod } = this.state;

        if (idclasificprod !== 2) {
            const recaptchaValue = recaptchaRef.current.getValue();
            this.props.onSubmit(recaptchaValue);
        }
    }

    show_box = () => {
        let box = document.getElementById("box")
        //RQTO. CDAT Y AHORRO DIGITAL 2025 - AMP - SE COMENTA
        const { idclasificprod } = this.state;
        let box2 = document.getElementById("box2")

        if (idclasificprod === 2) {
            box2.className += " show";
            box2.classList.remove("hide");

        } else {
            box.className += " show";
            box.classList.remove("hide");
        }

        this.setState({
            stateContent: !this.state.stateContent
        })
    }

    hide_box = () => {
        let box = document.getElementById("box")
        //RQTO. CDAT Y AHORRO DIGITAL 2025 - AMP
        const { idclasificprod } = this.state;
        let box2 = document.getElementById("box2")
        if (idclasificprod === 2) {
            box2.className += " hide";
            box2.classList.remove("show");

        } else {
            box.className += " hide";
            box.classList.remove("show");
        }

        this.setState({
            stateContent: !this.state.stateContent
        })
        this.cargarInformacion();
    }

    formatearMiles = (e) => {
        var num = e.target.value.replace(/\./g, '');
        if (e.target.value === "") {
            this.setState({
                stateDollar: false
            })
        } else {
            this.setState({
                stateDollar: true
            })
        }
        if (!isNaN(num)) {
            num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
            num = num.split('').reverse().join('').replace(/^[.]/, '');
            this.setState({
                monto: num
            })
        }
        else {
            this.setState({
                monto: e.target.value.replace(/[^\d.]*/g, '')
            })
        }
    }

    loadData = (data) => {
        this.setState({
            stateCampos: false
        })

        //RQTO. CDAT Y AHORRO DIGITAL 2025 - AMP
        //if (data.idprodutra === 12) {
        if (data.idtipoprod === 1) { // MODIFICADA AMP
            this.setState({
                stateCampos: true,
                plazo: ''
            })
        } else {
            this.setState({
                stateCampos: false,
                plazo: ''
            })
        }
        document.getElementById('' + this.state.idPintar + '').style.filter = "none";
        document.getElementById('' + this.state.idPintar + '').style.fontWeight = "normal";
        document.getElementById('' + data.idsimuladorprod + '').style.filter = "drop-shadow(8px 8px 10px " + data.color + ")";
        document.getElementById('' + data.idsimuladorprod + '').style.fontWeight = "bold";
        //RQTO. CRÉDITO DIGITAL FASE II 2026
        this.setState({
            rutaImg: data.rutafondosimul,
            idprodutra: data.idprodutra,
            prolinea: data.prolinea,
            descripcion: data.descsimulador,
            color: data.color,
            nombprodutra: data.nombprodutra,
            idPintar: data.idsimuladorprod,
            idclasificprod: data.idclasificprod,
            monto: '',
            plazo: '',
            montoSimulado: '',
            plazoSimulado: '',
            cuota: '',
            tasa_e_anual: '',
            tasa_n_anual: '',
            interes_ahorro: '',
            gmf: '',
            valor_renta: '',
            stateDollar: false,
            pasarela: false,
            formBlocker: false,
            errors: {}
        }, () => {
            this.checkProductSimulatorAttribute();
        });
    }

    //RQTO. CRÉDITO DIGITAL FASE II 2026
    checkProductSimulatorAttribute = () => {
        //RQTO. CRÉDITO DIGITAL, FASE II - JPGM/OASU 2026
        //const idprodUtra = this.state.idprodutra;
        const idprodUtra = sessionStorage.getItem("idprodutra");
        const body = {
            tran: 7,
            idprodvtadet: 0,
            idprodutra: idprodUtra,
            txtprodvtdet1: 'NA',
            txtprodvtdet2: 'NA',
            txtprodvtdet3: 'NA',
            rutaimgdetalle: 'NA',
            idtipovista: 0,
            infoadicional: 'NA',
            estado: 1,
            usucrea: 'NA',
        }

        ProductosDetallesGET_(body).then(response => {
            try {
                if (response.data.length > 0) {
                    this.setState({ pasarela: response.data[0].pasareladigital === 1 }, () => {
                        this.setState({ formBlocker: this.state.pasarela });
                    });

                } else {
                    console.log(response);
                }
            } catch (error) {
                console.log(error);
            }
        });
    }

    //RQTO. CRÉDITO DIGITAL FASE II 2026
    simularDatos = () => {
        this.setState({
            montoSimulado: '',
            plazoSimulado: '',
            cuota: '',
            tasa_e_anual: '',
            tasa_n_anual: '',
            interes_ahorro: '',
            gmf: '',
            valor_renta: ''
        })

        //formulario validado
        var nameP = this.props.match.params.name;

        const { errors, ...sinErrors } = this.state;
        const result = validate(sinErrors);
        this.setState({ errors: result });
        if (!Object.keys(result).length) {
            // RQTO. CDAT Y AHORRO DIGITAL - AJUSTE RESULTADOS - AMP - 2025 OCT
            const dataValida = {
                tran: 5,
                prolinea: this.state.prolinea,
                monto: parseFloat(this.state.monto.replace(/\./g, '')),
                plazo: parseInt(this.state.plazo),
                tipoprod: nameP === 'Ahorros' ? 1 : 2
            }

            ValidarCondicionesProductoSimula_(dataValida).then(response => {
                try {
                    //NOVEDADES - RQTO. CRÉDITO DIGITAL, FASE II - JPGM/OASU 2026
                    if (this.state.idtipoprod === 1) {
                        response.data[0].cumplecuota = 1;
                    }

                    response.data[0].cumplecuota = this.state.idtipoprod === 1 ? 1 : response.data[0].cumplecuota;
                    const { resultadomonto, resultadoplazo, cumplecuota, montomin, montomax, plamin, plamax, cuotamin, cuotacalc, codresp } = response.data[0];
                    if (resultadomonto !== 1 || resultadoplazo !== 1 || cumplecuota !== 1) {

                        let htmlMensaje = `
                               <p style="font-size:15px;color:#666;margin:0 0 14px;">Asegúrate de ingresar parámetros válidos para realizar la solicitud. Si el problema persiste, háznoslo saber para poder ayudarte a solucionarlo.</p>
                        `;

                        let title = "Ocurrió un problema en la petición";

                        if (!codresp) {
                            this.setState({
                                stateLoadign: false,
                                formBlocker: true
                            })

                            const tipoPlazo = (val) => val === 1
                                    ? (dataValida.tipoprod === 2 ? 'mes' : 'día')
                                    : (dataValida.tipoprod === 2 ? 'meses' : 'días');

                            const items = [];

                            if (resultadomonto !== 1) {
                                items.push(`
                                    <div style="background:#f9f9f9; border-radius:8px; border-left:3px solid #f47216ba; padding:12px 14px; margin-bottom:8px;">
                                        <p style="font-size:11px; font-weight:600; color:#f47216; margin:0 0 4px; text-transform:uppercase; letter-spacing:0.04em;">Monto</p>
                                        <p style="font-size:14px; color:#333; margin:0;">
                                            El monto debe estar entre <strong>$ ${formatterPeso.format(montomin)}</strong> y <strong>$ ${formatterPeso.format(montomax)}</strong>.
                                        </p>
                                    </div>
                                `);
                            }

                            if (resultadoplazo !== 1) {
                                items.push(`
                                    <div style="background:#f9f9f9; border-radius:8px; border-left:3px solid #f47216ba; padding:12px 14px; margin-bottom:8px;">
                                        <p style="font-size:11px; font-weight:600; color:#f47216; margin:0 0 4px; text-transform:uppercase; letter-spacing:0.04em;">Plazo</p>
                                        <p style="font-size:14px; color:#333; margin:0;">
                                            El plazo disponible para este monto es de <strong>${plamin}</strong> a <strong>${plamax} ${tipoPlazo(plamax)}</strong>.
                                        </p>
                                    </div>
                                `);
                            }

                            if (cumplecuota === 0 && resultadomonto === 1 && resultadoplazo === 1) {
                                items.push(`
                                    <div style="background:#f9f9f9; border-radius:8px; border-left:3px solid #f47216ba; padding:12px 14px; margin-bottom:8px;">
                                        <p style="font-size:11px; font-weight:600; color:#f47216; margin:0 0 4px; text-transform:uppercase; letter-spacing:0.04em;">Cuota mínima</p>
                                        <p style="font-size:14px; color:#333; margin:0;">
                                            Con ese monto y plazo, la cuota estimada es <strong>$ ${formatterPeso.format(cuotacalc)}</strong>, 
                                            por debajo de la cuota mínima de <strong>$ ${formatterPeso.format(cuotamin)}</strong>.
                                        </p>
                                    </div>
                                `);
                            }

                            htmlMensaje = `
                                <p style="font-size:15px;color:#666;margin:0 0 14px;">Ajusta los valores para continuar con la solicitud.</p>
                                ${items.join('')}
                            `;

                            title = "Condiciones no cumplidas";
                        }
                        //FIN

                        Swal.fire({
                            icon: 'warning',
                            //NOVEDADES - RQTO. CRÉDITO DIGITAL, FASE II - JPGM/CAGF 2026
                            //title: 'Petición denegada',
                            title: title,
                            //FIN
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            //NOVEDADES - RQTO. CRÉDITO DIGITAL, FASE II - JPGM/CAGF 2026
                            confirmButtonText: 'Entendido',
                            //FIN
                            html: htmlMensaje
                        });
                    }
                    else {
                        this.setState({
                            montomin: formatterPeso.format(response.data[0].montomin),
                            montomax: formatterPeso.format(response.data[0].montomax),
                            plamin: response.data[0].plamin,
                            plamax: response.data[0].plamax,
                        });
                        this.setState({
                            stateLoadign: true
                        })
                        //formulario validado
                        //var nameP = this.props.match.params.name;
                        const data = {
                            //RQTO. CDAT Y AHORRO DIGITAL - AMP - 2025 OCT
                            tran: 4,
                            prolinea: this.state.prolinea,
                            monto: parseFloat(this.state.monto.replace(/\./g, '')),
                            plazo: parseInt(this.state.plazo),
                            tipoprod: nameP === 'Ahorros' ? 1 : 2
                        }

                        const isValid = Object.values(data).every(
                            value => value !== undefined && value !== null && value !== ''
                        );

                        if (isValid) {
                            Simulacion_(data).then(response => {
                                try {
                                    if (response.data[0].codresp) {
                                        if (this.state.pasarela) {
                                            this.setState({
                                                formBlocker: true
                                            });
                                        }

                                        this.setState({
                                            stateLoadign: false
                                        })

                                        Swal.fire({
                                            icon: 'warning',
                                            text: '¡Petición denegada! ' + response.data[0].desresp + " Revisa los datos que ingresaste."
                                        })
                                    }
                                    else {
                                        this.setState({
                                            montoSimulado: formatterPeso.format(response.data[0].monto),
                                            plazoSimulado: response.data[0].plazo,
                                            cuota: formatterPeso.format(response.data[0].cuota),
                                            tasa_n_anual: response.data[0].tasanoanual,
                                            tasa_e_anual: response.data[0].tasaefanual,
                                            interes_ahorro: formatterPeso.format(response.data[0].interesahorro),
                                            gmf: formatterPeso.format(response.data[0].gmf),
                                            valor_renta: formatterPeso.format(response.data[0].valorRfte),
                                            stateLoadign: false,
                                            /*RQTO. CRÉDITO DIGITAL FASE II 2026 - SE AGREGA EL FORMBLOCKER:FALSE*/
                                            formBlocker: false
                                        })
                                    }
                                } catch (error) {
                                    this.setState({
                                        stateLoadign: false
                                    })
                                    console.log(error);
                                }
                            });
                        } else {
                            Swal.fire({
                                icon: 'warning',
                                text: '¡No es posible iniciar la simulación! Faltan parámetros para realizar esto.'
                            });
                        }

                    }
                } catch (error) {
                    this.setState({
                        stateLoadign: false
                    })
                    console.log(error);
                }
            });

        }
    }

    render() {
        const { errors } = this.state;
        // RQTO. CDAT Y AHORRO DIGITAL - AJUSTE RESULTADOS - AMP - 2025 OCT 
        const total_rendimiento_monto = parseFloat((this.state.interes_ahorro || "0").toString().replace(/\./g, "")) + parseFloat((this.state.montoSimulado || "0").toString().replace(/\./g, ""));

        return (
            <React.Fragment>
                <div className="simulador">
                    <div className="simulador_items">
                        {this.state.stateImg ? (
                            <img className="img-fluid img-fondo-credito" src={`${URLImgFront}/assets${this.state.rutaImg}`} alt={this.state.rutaImg} />
                        ) : (
                            <React.Fragment></React.Fragment>
                        )}
                        {this.state.stateContent ? (
                            <React.Fragment>
                                <div className="contenedor">
                                    <div className="lista" id="list_productos">
                                        <MDBIcon icon="angle-left" className="icon-left" style={{ display: 'none' }} />
                                        <Link to="/" className="diseño_U">
                                            <img className="img-fluid img-logo-u" src={`${URLImgFront}/assets/logo/logoU.png`} alt="logoU.png" />
                                        </Link>
                                        {this.state.stateBVertical ? (
                                            <React.Fragment>
                                                <ul className="barra_vertical">
                                                    {this.state.simuladorData.map((e, i) => {
                                                        if (e.posicion === 1) {
                                                            return [
                                                                <React.Fragment key={i}>
                                                                    <li onClick={() => { this.loadData(e) }} className="li mt-1" id={e.idsimuladorprod}>
                                                                        <div>
                                                                            <img style={{ width: '55px', height: '55px' }} className="img-fluid" src={`${URLImgFront}/assets${e.rutaiconosimul}`} alt={e.nombprodutra} />
                                                                            <p>{e.nombprodutra}</p>
                                                                        </div>

                                                                    </li>
                                                                </React.Fragment>
                                                            ]
                                                        } else {
                                                            return [
                                                                <React.Fragment key={i}></React.Fragment>
                                                            ]
                                                        }
                                                    })}
                                                </ul>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment></React.Fragment>
                                        )}
                                        {this.state.stateBHorizontal ? (
                                            <React.Fragment>
                                                <ul className="barra_horizontal">
                                                    {this.state.simuladorData.map((e, i) => {
                                                        if (e.posicion === 0) {
                                                            return [
                                                                <React.Fragment key={i}>
                                                                    <li onClick={() => { this.loadData(e) }} className="li mt-1" id={e.idsimuladorprod}>
                                                                        <img style={{ width: '55px', height: '55px' }} className="img-fluid" id={e.idsimuladorprod} src={`${URLImgFront}/assets${e.rutaiconosimul}`} alt={e.nombprodutra} />
                                                                        <p>{e.nombprodutra}</p>
                                                                    </li>
                                                                </React.Fragment>
                                                            ]
                                                        } else {
                                                            return [
                                                                <React.Fragment key={i}></React.Fragment>
                                                            ]
                                                        }
                                                    })}
                                                </ul>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment></React.Fragment>
                                        )}
                                        <MDBIcon icon="angle-right" className="icon-right" style={{ display: 'none' }} />
                                    </div>
                                    <div className="contenedor_formulario">
                                        <ul className="h">
                                            <li>
                                                <div className="form">
                                                    <div className="form_data text-center pt-4">
                                                        {/* CDAT Y AHORRO DIGITAL - AJUSTE RESULTADOS - AMP - 2025 OCT*/}
                                                        {/*{((this.state.idtipoprod === 1) && (this.state.idclasificprod === 2) || (this.state.idclasificprod === 1) ) ? (
                                                            <>
                                                                <MDBInput size="ms" label="Tu Inversión" onKeyUp={this.formatearMiles} onChange={this.textInput} name="monto" value={this.state.monto} outline className="pt-3 pl-4 font-weight-bold" style={{ border: '1px solid #d9dada' }} />{this.state.stateDollar ? <MDBIcon icon="dollar-sign" style={{ position: 'absolute', left: '34px', marginTop: '-67px' }} /> : <div></div>}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <MDBInput size="ms" label="Monto a solicitar" onKeyUp={this.formatearMiles} onChange={this.textInput} name="monto" value={this.state.monto} outline className="pt-3 pl-4 font-weight-bold" style={{ border: '1px solid #d9dada' }} />{this.state.stateDollar ? <MDBIcon icon="dollar-sign" style={{ position: 'absolute', left: '34px', marginTop: '-67px' }} /> : <div></div>}
                                                            </>
                                                        )}*/}

                                                        {/*RQTO. CRÉDITO DIGITAL, FASE II - JPGM/OASU 2026*/}
                                                        <MDBInput size="ms" label={this.state.idtipoprod === 1 && (this.state.idclasificprod === 2 || this.state.idclasificprod === 1) ? "Tu Inversión" : "Monto a solicitar"} onKeyUp={this.formatearMiles} onChange={this.textInput} name="monto" value={this.state.monto} outline className="pt-3 pl-4 font-weight-bold" style={{ border: '1px solid #d9dada' }} />{this.state.stateDollar ? <MDBIcon icon="dollar-sign" style={{ position: 'absolute', left: '34px', marginTop: '-67px' }} /> : <div></div>}

                                                        {errors.monto && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', marginTop: '-42px', left: '25px' }}>{errors.monto}</strong>}
                                                        <MDBInput size="ms" label={this.state.stateCampos ? "Plazo en días" : "Plazo en meses"} outline onChange={this.textInput} value={this.state.plazo} name="plazo" className="pt-3 font-weight-bold" style={{ border: '1px solid #d9dada' }} />
                                                        {errors.plazo && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', marginTop: '-42px', left: '25px' }}>{errors.plazo}</strong>}
                                                        <button onClick={this.simularDatos} className="btn font-weight-bold px-5" style={{ border: '1px solid ' + this.state.color + '', color: '' + this.state.color + '', fontSize: '15px', borderRadius: '20px' }}>Simular</button>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="descr pb-0">
                                                <div className="card pb-0">
                                                    <div className="card-body pb-0">
                                                        <p>{this.state.descripcion}</p>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <ul className="i">
                                            <li>
                                                {/* CDAT Y AHORRO DIGITAL - AJUSTE RESULTADOS - AMP - 2025 OCT*/}
                                                <div className="card bg-transparent">
                                                    <div style={{ zIndex: '1', background: '' + this.state.color + '', opacity: '.1', width: '100%', height: '100%', position: 'absolute' }}></div>
                                                    <div className="card-body" style={{ zIndex: '3' }}>
                                                        {/* RQTO. CDAT Y AHORRO DIGITAL - AJUSTE RESLTADOS - AMP - 2025 OCT - se agrega h-[200px] sm:h-[300px]" style={{ height: '250px' }}*/}
                                                        <div className="row h-[200px] sm:h-[300px]" style={{ height: '250px' }}>
                                                            <div className="col-md-5">
                                                                {/* RQTO. CDAT Y AHORRO DIGITAL - AJUSTE RESLTADOS - AMP - 2025 OCT - se agrega style={{ display: 'none' }}*/}
                                                                <p style={{ display: 'none' }} > Monto: <MDBIcon icon="dollar-sign" style={{ color: '' + this.state.color + '' }} /> <b>{this.state.montoSimulado}</b></p>
                                                                {/* RQTO. CDAT Y AHORRO DIGITAL - AJUSTE RESLTADOS - AMP - 2025 OCT - se agrega style={{ display: 'none' }}*/}
                                                                <p style={{ display: 'none' }}>Plazo: <b>{this.state.plazoSimulado}</b></p>
                                                                {this.state.stateCampos ? (<React.Fragment>
                                                                    {/* RQTO. CDAT Y AHORRO DIGITAL -  AMP - 2025 OCT - Interes de Ahorro */}
                                                                    <p>Tu Rendimiento: <MDBIcon icon="dollar-sign" style={{ color: '' + this.state.color + '' }} /><b> {this.state.interes_ahorro}</b></p>
                                                                </React.Fragment>) : (<React.Fragment>
                                                                    <p>Cuota: <MDBIcon icon="dollar-sign" style={{ color: '' + this.state.color + '' }} /> <b>{this.state.cuota}</b></p>
                                                                </React.Fragment>)}

                                                                {/* RQTO. CDAT Y AHORRO DIGITAL - AMP - 2025 OCT -  SE CAMBIA TITULO -> Tasa efectiva anual: , Tasa nominal anual */}
                                                                <p>Tasa E.A: <b>{this.state.tasa_e_anual}</b> <MDBIcon icon="percent" style={{ color: '' + this.state.color + '' }} /></p>
                                                                <p>Tasa N.A: <b>{this.state.tasa_n_anual}</b> <MDBIcon icon="percent" style={{ color: '' + this.state.color + '' }} /></p>
                                                            </div>
                                                            {this.state.stateCampos ? (
                                                                <React.Fragment>
                                                                    <div className="col-md-7">
                                                                        <p>GMF: <MDBIcon icon="dollar-sign" style={{ color: '' + this.state.color + '' }} /><b> {this.state.gmf}</b></p>
                                                                        {/* RQTO. CDAT Y AHORRO DIGITAL -  AMP - 2025 OCT - SE CAMBIA TITULO Valor Retefuenteo */}
                                                                        <p>Retefuente: <MDBIcon icon="dollar-sign" style={{ color: '' + this.state.color + '' }} /><b> {this.state.valor_renta}</b></p>

                                                                        {/* RQTO. CDAT Y AHORRO DIGITAL - AJUSTE RESLTADOS - AMP - 2025 OCT*/}
                                                                        {((this.state.idtipoprod === 1) && (this.state.idclasificprod === 2)) && (
                                                                            <>
                                                                                <p>Tu Rendimiento + Capital: <MDBIcon icon="dollar-sign" style={{ color: '' + this.state.color + '' }} /><b>  {formatterPeso.format(total_rendimiento_monto)} </b></p>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </React.Fragment>
                                                            ) : (<React.Fragment></React.Fragment>)}
                                                        </div>

                                                        {/* RQTO. CDAT Y AHORRO DIGITAL - AJUSTE RESLTADOS - AMP - 2025 OCT - CAMBIAR  bottom: '30px' */}
                                                        {((this.state.idtipoprod === 1) && (this.state.idclasificprod === 2)) ? (
                                                            <>
                                                                {/*RQTO. CRÉDITO DIGITAL FASE II 2026*/}
                                                                <button disabled={this.state.formBlocker} onClick={this.show_box} className="btn font-weight-bold btn_s_inferior" style={{ background: '' + this.state.color + '', color: '#fff', fontSize: '15px', position: 'absolute', right: '0', bottom: '30px' }}>CREAR CDAT&nbsp; </button>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {/*RQTO. CRÉDITO DIGITAL FASE II 2026*/}
                                                                <button disabled={this.state.formBlocker} onClick={this.show_box} className="btn font-weight-bold btn_s_inferior" style={{ background: '' + this.state.color + '', color: '#fff', fontSize: '15px', position: 'absolute', right: '0', bottom: '30px' }}>Solicitar&nbsp; </button>
                                                            </>
                                                        )}

                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </React.Fragment>
                        ) : (
                            <React.Fragment></React.Fragment>
                        )}
                    </div>

                    <div className="solicitud" id="box">
                        {/* RQTO. CDAT Y AHORRO DIGITAL - AJUSTES SEGUNDA ENTREGA - SE AJUSTA AMP - 2025 OCT */}
                        <div onClick={this.hide_box} className="cerrar"><p style={{ color: '' + this.state.color + '', cursor: 'pointer', paddingLeft: '10px' }}><MDBIcon icon="arrow-left" size="2x" className="icon pt-2" /></p></div>
                        <div className="container d-flex align-items-center form py-5" style={{ height: '100vh', overflow: 'hidden', overflowY: 'scroll' }}>
                            <div className="formularioinfo row pl-3" style={{ paddingTop: '590px' }}>
                                {/*INICIO MODIFICACIÓN - RQTO CRÉDITO DIGITAL FII JPGM 2026/00/00*/}
                                <div className="col-sm-12 py-2" style={{ color: '' + this.state.color + '', fontWeight: 'bold', paddingInline: 0 }}>
                                {/*<div className="col-sm-12 py-2" style={{ color: '' + this.state.color + '', fontWeight: 'bold' }}>*/}
                                {/*FIN*/}
                                    <h5>Solicitud Asesoria de {this.props.match.params.name} <b>{this.state.nombprodutra}</b></h5>
                                    <hr style={{ background: '' + this.state.color + '' }} />
                                </div>
                                <FormAsesoria color={this.state.color} idprodserv={this.props.match.params.name} />
                            </div>
                        </div>
                    </div>

                    {/* RQTO. CDAT Y AHORRO DIGITAL 2025 OCT - AMP */}
                    <div className="solicitudDigital" id="box2">
                        {/* RQTO. CDAT Y AHORRO DIGITAL - AJUSTES SEGUNDA ENTREGA - SE AJUSTA AMP - 2025 OCT */}
                        <div onClick={this.hide_box} className="cerrar"><p style={{ color: '' + this.state.color + '', cursor: 'pointer', paddingLeft: '10px' }}><MDBIcon icon="arrow-left" size="2x" className="icon pt-2" /></p></div>
                        <div className="container d-flex align-items-center form py-5" style={{ height: '70vh', overflow: 'hidden', overflowY: 'scroll' }}>
                            {/*RQTO. CRÉDITO DIGITAL FASE II 2026*/}
                            <div className="formularioinfo row pl-3" style={{ paddingTop: '20px' }}>
                                <div className="col-sm-12 py-2" style={{ color: '' + this.state.color + '', fontWeight: 'bold', paddingInline: 0 }}>
                                    {(this.state.idclasificprod === 2 && this.state.idtipoprod === 2) ? (
                                        <h5>Solicitud <b>{this.state.nombprodutra}</b></h5>
                                    ) : (
                                        <h5>Solicitud Asesoria de {this.props.match.params.name} <b>{this.state.nombprodutra}</b></h5>
                                    )}

                                    <hr style={{ background: '' + this.state.color + '' }} />
                                </div>

                                {this.state.montoSimulado && (
                                    <FormAsesoriaDigital
                                        /*RQTO. CRÉDITO DIGITAL FASE II 2026*/
                                        prolinea={this.state.prolinea}
                                        idclasificprod={this.state.idclasificprod}
                                        pasarela={this.state.pasarela}
                                        color={this.state.color}
                                        idprodserv={this.props.match.params.name}
                                        idtipoprod={this.state.idtipoprod}
                                        montoSimulado={this.state.montoSimulado}
                                        interes_ahorro={this.state.interes_ahorro}
                                        valor_renta={this.state.valor_renta}
                                        gmf={this.state.gmf}
                                        plazoSimulado={this.state.plazoSimulado}
                                        tasa_n_anual={this.state.tasa_n_anual}
                                        tasa_e_anual={this.state.tasa_e_anual}
                                        prolineahorros={this.state.prolinea}

                                    />
                                )}
                                {/*FIN*/}
                            </div>
                        </div>
                    </div>

                </div>
                {this.state.stateLoadign ? (
                    <Loading />
                ) : (<React.Fragment></React.Fragment>)}
            </React.Fragment>
        );
    }
}

export default Simula;